import CustomZObject from './CustomZObject.js';
import {doc} from './shader/docs.js';
import {definitions} from './canvas/index.js';
import {isNumber} from "utils/IsNumber.js";

export default class ZScript extends CustomZObject {
    constructor(zobject) {
        super(zobject);

        this.newOutlet("script");
        this.code = "";
        this.logs = [];
        this.storedMatches = [];
    }

    clearErrors(errors) {
        this.syntaxErrors = undefined;
    }

    onNewErrors(errors) {
        let error = errors[0];
        if (error.length < 7) {
            return;
        }
        let vertex = error[6].split('\n');
        let fragment = error[7].split('\n');

        let v = this.checkCode(vertex, true);
        let f = this.checkCode(fragment);

        this.syntaxErrors = v || f;
    }

    checkCode(lines, isVertex) {
        let i=0;
        let codeStart = -1;
        let myCodeStart = -1;
        let codeLines = this.code.split("\n").filter(x => x !== "");
        for (let line of lines) {
            if (line.includes(codeLines[0])) {
                myCodeStart = i;
            }
            if (line.includes("1: #version 300 es")) {
                codeStart = i;
            }
            if (line.includes("equirectUv")) {
                myCodeStart = i + 6;
            }
            if (isVertex && line.startsWith("57:")) {
                myCodeStart = i+1;
            }
            i++;
        }

        let syntaxErrors = lines.slice(1, codeStart);
        let parsedErrors = [];
        for (let err of syntaxErrors) {
            if (err.includes("#version")) {
                continue;
            }
            let tokens = err.split(" ");
            let lineStr = tokens[1].split(":")[1];
            let lineNumber = parseFloat(lineStr) - myCodeStart;
            if (!isVertex) {
                lineNumber += 2;
            } else {
                lineNumber += 1;
            }
            parsedErrors.push(
                {
                    lineNumber,
                    errorMessage: err.slice(err.indexOf(lineStr) + lineStr.length)
                });
        }

        let myCode = lines.slice(myCodeStart).map(
            x => x.slice(x.indexOf(":") + 2));;


        let parsedCode = this.parsedCode || this.code;
        if (myCode.length === 1) {
            return undefined;
        }

        if (myCode.every(line => parsedCode.includes(line))) {
            return parsedErrors;
        }

        return undefined;
    }

    getJson(isPreset) {
        return {
            ... super.getJson(isPreset),
            code: this.code
        };
    }

    fromJson(json, isCopy) {
        super.fromJson(json, isCopy);
        this.code = json.code;
    }

    get doc() {
        return doc;
    }

    eval(code) {
        this.code = code;
    }

    hasSyntaxError(code) {
        return false;
    }

    set code(x) {
        this._script = x;
        x = this.parseScript(x);
        this.sendMessage("script", x);
    }

    get parsedCode() {
        this.parseScript(this._script);
    }

    parseScript(code) {
        if (!code) {
            return undefined;
        }
        let regex = /@[a-z]*/g;
        let matches = code.match(regex);

        if (!matches) {
            return code;
        }

        for (let match of matches) {
            let importName = match.slice(1);
            if (!this.inlets[importName]) {
                this.newInlet(
                    importName,
                    ([msg]) => {
                        this.storedMatches[importName] = msg;

                        // update the code it receives a msg
                        this.eval(this.code);
                    });
            }
            code = code.replaceAll(match, this.storedMatches[importName] || "");
        }
        return code;
    }

    get code() {
        return this._script;
    }
}
 
